'use strict';

module.exports = function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/style/removeStyle.js
 ** module id = 995
 ** module chunks = 1
 **/